/**
 * Проверяет и правит значение из qs
 */
export const prepareQSParam = (value?: string | null) => {
  return (value || '').trim();
};
